export default {
    setErrors(state, data) {
        state.error = data
    }
}
